import { LoginService } from 'src/app/services/general/login.service';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from 'src/app/services/general/popup.service';
import { NavigationExtras, Params, Router, ActivatedRoute } from '@angular/router';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { ConfigService } from 'src/app/services/general/config.service';
import { UserService } from 'src/app/services/user/user.service';
import { LinkService } from 'src/app/services/general/link.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/services/user/auth.service';
import { ModalController } from '@ionic/angular';
import { AccountsSetupComponent } from 'src/app/components/accounts/accounts-setup/accounts-setup.component';
import { LanguageService } from 'src/app/services/general/language.service';

@Component({
  selector: 'app-accounts-trial',
  templateUrl: './accounts-trial.page.html',
  styleUrls: ['./accounts-trial.page.scss'],
})
export class AccountsTrialPage implements OnInit, OnDestroy {

  language: string;

  private backAddPage: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private modalController: ModalController,
    private accountsListService: AccountsListService,
    private languageService: LanguageService,
    private authService: AuthService,
    private userService: UserService,
    private loginService: LoginService,
    private linkService: LinkService,
    private configService: ConfigService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.backAddPage) {
        this.backAddPage = true;
      } else if (param?.backAddPage) {
        this.backAddPage = true;
      } else {
        this.backAddPage = false;
      }
    });
  }

  ionViewWillEnter() {
    this.initialize();
  }

  initialize() {
    if (!this.checkIsTrialAvailable()) {
      this.promptTrialLimit();
    }
    const language = this.languageService.getUserLanguage()?.code;
    if (language === 'zh') {
      this.language = 'zh-tw';
    } else if (language === 'ms') {
      this.language = 'en';
    } else {
      this.language = language.toLowerCase();
    }
  }

  getTrialMaxGuest() {
    return this.configService?.trial?.trial_guest ? this.configService.trial.trial_guest : 30;
  }

  getTrialLimit() {
    return this.configService?.trial?.trial_new ? this.configService.trial.trial_new : 1;
  }

  goBack() {
    if (this.backAddPage) {
      this.goAccountsAddPage();
    } else {
      this.goMainPage();
    }
  }

  checkIsTrialAvailable() {
    if (this.accountsListService.isNewTrialAvailable()) {
      return true;
    } else {
      return false;
    }
  }

  async promptTrialLimit() {
    const alert = await this.popupService.presentAlert(
      this.translate.instant('ACCOUNTS.trial.msg.trial_limit', { count: this.getTrialLimit() }));
    alert.onWillDismiss().then(() => {
      this.goMainPage();
    });
  }

  /**
   * Check user login
   */
   async checkUserLogin() {
    await this.popupService.presentLoading();
    if (this.authService.currentUser) {
      if (this.userService.user?.name) {
        this.checkAnonymousLogin();
      } else {
        await this.popupService.dismissLoading();
        const modal = await this.loginService.presentUserSetupModal();
        modal.onDidDismiss().then(() => {
          this.checkAnonymousLogin();
          this.loginService.userSetupModal = null;
        });
      }
    } else {
      this.presentLoginModal(false, false);
    }
  }

  /**
   * Check anonymous login
   */
  async checkAnonymousLogin() {
    if (this.userService?.user?.isAnonymous) {
      this.presentLoginModal(false, false, true);
    } else {
      this.presentAccountSetupModal(false);
    }
  }

  /**
   * Present login modal
   * @param loginRequired login required
   * @param showAnonymousLogin show anonymous login
   * @param linkProvider link provider
   */
  async presentLoginModal(loginRequired?: boolean, showAnonymousLogin?: boolean, linkProvider?: boolean) {
    await this.popupService.dismissLoading();
    const modal = await this.loginService.presentLoginModal(loginRequired, showAnonymousLogin, linkProvider);
    modal.onDidDismiss().then(async () => {
      if (this.userService.user && (showAnonymousLogin || !this.userService?.user?.isAnonymous)) {
        await this.popupService.presentLoading();
        this.presentAccountSetupModal(false);
      }
    });
  }

  async presentAccountSetupModal(premium?: boolean) {
    const modal = await this.modalController.create({
      component: AccountsSetupComponent,
      componentProps: {
        premium
      }
    });
    modal.present();
    this.popupService.dismissLoading();
  }

  // goAccountSetupPage(premium?: boolean ) {
  //   this.popupService.dismissLoading();
  //   if (this.checkIsTrialAvailable()) {
  //     const navigationExtras: NavigationExtras = {
  //       state: { premium }
  //     };
  //     this.router.navigate(['/accounts/setup'], navigationExtras);
  //   } else {
  //     this.promptTrialLimit();
  //   }
  // }

  goPremiumPage() {
    const navigationExtras: NavigationExtras = {
      state: { backPremiumPage: true, backAddPage: this.backAddPage }
    };
    this.router.navigate(['/subscription/premium'], navigationExtras);
  }

  goMainPage() {
    this.linkService.goMainPage();
  }

  goAccountsAddPage() {
    this.router.navigate(['/tabs-accounts/list']);
  }



}
